import React, { useState, useMemo, useEffect, useRef } from 'react';
import { Input, Checkbox, List, Row, Col, Modal, Select } from 'antd';

const { Search } = Input;

const SearchableCheckableMediaList = ({
    data = [],
    multiple = true,
    onItemsSelected = () => { },
    headerTitle = "Title",
    values = [],
}) => {

    const initialLoadRef = useRef(true);
    const [searchText, setSearchText] = useState('');
    const [checkedList, setCheckedList] = useState([]);
    const isMounted = useRef(false);
    const allIDs = useMemo(() => data.map((item) => item.id), [data]);
    const [selectedTypes, setSelectedTypes] = useState([]);
    const [previewItem, setPreviewItem] = useState(null);
    const [isPreviewVisible, setIsPreviewVisible] = useState(false);
    // Set all checked for multiple or none for single
    // useEffect(() => {
    //   if (checkedList.length === 0) {
    //     if (multiple) {
    //       setCheckedList(allIDs);
    //     } else {
    //       setCheckedList([]);
    //     }
    //   }
    // }, [allIDs]);

    // Handle Search Input

    const allTypes = useMemo(() => {
        const types = Array.from(new Set(data.map(item => item.type)));
        return types;
    }, [data]);

    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);

    const handleSearchChange = (e) => {
        setSearchText(e.target.value.toLowerCase());
    };

    // Filtered by search
    // const filteredData = useMemo(() => {
    //     return data.filter((item) =>
    //         item.title.toLowerCase().includes(searchText)
    //     );
    // }, [data, searchText]);
    const filteredData = useMemo(() => {
        return data.filter((item) => {
            const matchesSearch = item.title.toLowerCase().includes(searchText);
            const matchesType = selectedTypes.length === 0 || selectedTypes.includes(item.type);
            return matchesSearch && matchesType;
        });
    }, [data, searchText, selectedTypes]);

    const filteredIDs = useMemo(() => filteredData.map((item) => item.id), [filteredData]);

    const currentCheckedIDs = useMemo(
        () => filteredIDs.filter((id) => checkedList.includes(id)),
        [filteredIDs, checkedList]
    );

    const isAllSelected =
        multiple && filteredIDs.length > 0 && currentCheckedIDs.length === filteredIDs.length;

    const toggleSelectAll = (checked) => {
        if (!multiple) return;
        setCheckedList((prev) =>
            checked ? Array.from(new Set([...prev, ...filteredIDs])) : prev.filter((id) => !filteredIDs.includes(id))
        );
    };

    const handleCheck = (checked, id) => {
        console.log(`handleCheck: ${checked} for id: ${id}`);
        if (multiple) {
            setCheckedList((prev) =>
                checked ? [...prev, id] : prev.filter((item) => item !== id)
            );
        } else {
            setCheckedList(checked ? [id] : []);
        }
    };

    // Notify parent on change
    useEffect(() => {
        if (!isMounted.current) return;

        const selectedData = data.filter((item) => checkedList.includes(item.id));
        const selection = multiple ? selectedData : selectedData[0] || null;

        // Only call if value actually changed
        if (JSON.stringify(selection) !== JSON.stringify(prevSelectionRef.current)) {
            prevSelectionRef.current = selection;
            onItemsSelected(selection);
        }
    }, [checkedList, data, multiple, onItemsSelected]);

    const prevSelectionRef = useRef(null);


    useEffect(() => {
        setCheckedList((prev) => {
            if (initialLoadRef.current) {
                initialLoadRef.current = false;
                return values.length > 0 ? values : prev;
            }
            return prev;
        });
    }, [values]);

    const handlePreview = (item) => {
        setPreviewItem(item);
        setIsPreviewVisible(true);
    };

    return (
        <div style={{ width: '100%' }}>
            <Row justify="space-between" align="middle" style={{ marginBottom: 8 }}>
                <Col flex="auto">
                    <Search
                        placeholder="Search"
                        allowClear
                        onChange={handleSearchChange}
                        style={{ width: '100%' }}
                    />
                </Col>
                {multiple && (
                    <Col style={{ marginLeft: 16, whiteSpace: 'nowrap' }}>
                        {checkedList.length} of {data.length} selected
                    </Col>
                )}
            </Row>

            <Row justify="space-between" align="middle" style={{ marginBottom: 12 }}>
                <Col flex="auto">
                    {allTypes.length > 0 && (
                        <Select
                            mode="multiple"
                            allowClear

                            placeholder="Filter by type"
                            value={selectedTypes}
                            onChange={setSelectedTypes}
                            style={{ width: '100%' }}
                            options={allTypes.map((type) => ({ label: type, value: type }))}
                        />
                    )}
                </Col>
            </Row>
            {multiple && (
                <Row justify="space-between" align="middle" style={{ marginBottom: 12 }}>
                    <Col flex="auto">
                        <Checkbox
                            checked={isAllSelected}
                            indeterminate={!isAllSelected && currentCheckedIDs.length > 0}
                            onChange={(e) => toggleSelectAll(e.target.checked)}
                        >
                            Select All
                        </Checkbox>
                    </Col>
                </Row>
            )}

            {/* Header */}
            <div
                style={{
                    backgroundColor: '#f0f0f0',
                    color: '#333',
                    height: '3em',
                    fontWeight: "semibold",
                    display: 'flex',
                    justifyContent: 'start',
                    alignItems: 'center',
                    padding: '14px',
                    paddingLeft: "24px"
                }}
            >
                {headerTitle}
            </div>

            {/* Scrollable list */}
            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                <List
                    bordered={false}
                    dataSource={filteredData}
                    renderItem={(item) => (
                        <List.Item
                            style={{
                                backgroundColor: "#fff",
                                padding: '8px 16px',
                                cursor: 'pointer',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                <Checkbox
                                    checked={checkedList.includes(item.id)}
                                    onChange={(e) => handleCheck(e.target.checked, item.id)}
                                >
                                    <span style={{ fontWeight: 500 }}>{item.title}</span>
                                    <span style={{ color: '#888', marginLeft: 8 }}>({item.type})</span>
                                </Checkbox>
                            </div>

                            {['Image', 'Video', 'Web', 'VideoUrl', 'StreamingUrl'].includes(item.type) &&
                                <button
                                    style={{
                                        backgroundColor: '#1890ff',
                                        border: 'none',
                                        color: 'white',
                                        padding: '4px 12px',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => handlePreview(item)}
                                >
                                    Preview
                                </button>
                            }
                        </List.Item>
                    )}
                    locale={{ emptyText: 'No items found' }}
                />

            </div>
            {/* Preview Modal */}
            {previewItem && (
                <div>
                    <Modal
                        open={isPreviewVisible}
                        onCancel={() => setIsPreviewVisible(false)}
                        footer={null}
                        title={previewItem.title}
                        width={previewItem.type === 'Image' ? 600 : 800}
                    >
                        {previewItem.type === 'Image' && previewItem.url && (
                            <img
                                src={previewItem.url}
                                alt={previewItem.title}
                                style={{ maxWidth: '100%', maxHeight: '70vh', borderRadius: 8 }}
                            />
                        )}

                        {['Video', 'VideoUrl', 'StreamingUrl'].includes(previewItem.type) && previewItem.url && (
                            <video
                                src={previewItem.url}
                                controls
                                style={{ width: '100%', maxHeight: '70vh', borderRadius: 8 }}
                            />
                        )}

                        {previewItem.type === 'Web' && previewItem.url && (
                            <iframe
                                src={previewItem.url}
                                style={{ width: '100%', height: '60vh', border: 'none' }}
                                title={previewItem.title}
                            />
                        )}

                        {!previewItem.url && (
                            <div>Preview not available.</div>
                        )}
                    </Modal>
                </div>
            )}
        </div>
    );
};

export default SearchableCheckableMediaList;
